import { render } from "./view-table.vue?vue&type=template&id=cd52d626"
import script from "./view-table.vue?vue&type=script&lang=js"
export * from "./view-table.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__